import React from 'react';
import PropTypes from 'prop-types';
import MiniLoader from './miniLoader';
const Ending = _ref => {
  let _ref$endingMessage = _ref.endingMessage,
    endingMessage = _ref$endingMessage === void 0 ? null : _ref$endingMessage,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  if (endingMessage) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, endingMessage);
  }
  return isLoading ? /*#__PURE__*/React.createElement(MiniLoader, null) : null;
};
Ending.propTypes = {
  endingMessage: PropTypes.string,
  isLoading: PropTypes.bool
};
export default Ending;